require('./components/components_module');
require('./components/popover/popover');
require('./components/popup/popup');
require('./components/popup_container/popup_container');
require('./services/popup_config_service/popup_config_service');
require('./services/popup_config_service/popup_config_service_type');
require('./services/services_module');



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-popup/src/core.ts